import React, { ReactElement } from 'react';
import IconButton from '@material-ui/core/IconButton';
import useStyles from './styles';
import Collapse from '@material-ui/core/Collapse';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Box /*, Typography*/ } from '@material-ui/core';
// import ChevronRightIcon from '@material-ui/icons/ChevronRight';

interface IExpandableListItemProps {
  renderDataHeader: () => ReactElement;
  renderDataBody: () => ReactElement;
}
export default function ExpandableListItem(props: IExpandableListItemProps) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <React.Fragment>
      <Box
        display={'flex'}
        className={classes.headerBox}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'center'}
        onClick={handleExpandClick}
      >
        {props.renderDataHeader()}
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </Box>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {props.renderDataBody()}
      </Collapse>
    </React.Fragment>
  );
}
